import { render, staticRenderFns } from "./funcionarios.vue?vue&type=template&id=22c2aa8c"
import script from "./funcionarios.vue?vue&type=script&lang=js"
export * from "./funcionarios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports